import React from "react";
import PropTypes from "prop-types";
import { VIEW_COLUMNS } from "../../../../config/customerColumnsConfig";

const ViewCustomerRow = ({ customer, selectedCustomer, onRowClick }) => {
  const isSelected =
    selectedCustomer && selectedCustomer.customerID === customer.customerID;
  return (
    <tr
      onClick={() => onRowClick(customer)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      {VIEW_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.render ? col.render(customer) : customer[col.key]}
        </td>
      ))}
    </tr>
  );
};

ViewCustomerRow.propTypes = {
  customer: PropTypes.object.isRequired,
  selectedCustomer: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
};

export default ViewCustomerRow;
